<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Platform Fees</div>
      </legend>
    </div>
    <div class="col-md-9">
      <div class="row form-group fieldIsRequired">
        <label
          class="col-md-6 col-lg-4 mt-auto mb-auto control-label text-right"
          for="perTransAuthFee"
          *ngIf="!isInstaMed"
        >
          Per Transaction Auth Fee
        </label>

        <label
          class="col-md-6 col-lg-4 mt-auto mb-auto control-label text-right"
          for="perTransAuthFee"
          *ngIf="isInstaMed"
        >
          Per Credit Card Trans Fee
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dollarAddAuthFee">$</span>
            <input
              class="form-control"
              aria-describedby="dollarAddOn"
              [ngClass]="{
                'is-invalid':
                  parentGroup.controls.perTransAuthFee.invalid &&
                  (parentGroup.controls.perTransAuthFee.dirty ||
                    parentGroup.controls.perTransAuthFee.touched)
              }"
              type="number"
              formControlName="perTransAuthFee"
              (blur)="decimalDollarAmount('perTransAuthFee')"
              step="0.01"
              id="perTransAuthFee"
              placeholder="0.00"
            />
          </div>
          <div
            *ngIf="
              parentGroup.controls.perTransAuthFee.invalid &&
              (parentGroup.controls.perTransAuthFee.dirty ||
                parentGroup.controls.perTransAuthFee.touched)
            "
            class="mt-1"
          >
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransAuthFee.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransAuthFee.errors?.max"
            >
              Value is too high. Max is 999999.99.
            </div>
            <div
              class="text-danger"
              *ngIf="
                parentGroup.controls.perTransAuthFee.errors?.min &&
                (parentGroup.controls.perTransAuthFee.value === 0 ||
                  parentGroup.controls.perTransAuthFee.value === '0.00')
              "
            >
              Value must be greater than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransAuthFee.errors?.pattern"
            >
              Please enter a valid dollar amount.
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group fieldIsRequired" *ngIf="!isInstaMed">
        <label
          class="col-md-6 col-lg-4 control-label mt-auto mb-auto text-right"
          for="platformFeeRefund"
        >
          Per Transaction Refund Fee
        </label>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dollarAddOnRefundFee">$</span>
            <input
              class="form-control"
              aria-describedby="dollarAddOnRefundFee"
              [ngClass]="{
                'is-invalid':
                  parentGroup.controls.perTransRefundFee.invalid &&
                  (parentGroup.controls.perTransRefundFee.dirty ||
                    parentGroup.controls.perTransRefundFee.touched)
              }"
              type="number"
              formControlName="perTransRefundFee"
              (blur)="decimalDollarAmount('perTransRefundFee')"
              id="platformFeeRefund"
              step="0.01"
              placeholder="0.00"
            />
          </div>
          <div
            *ngIf="
              parentGroup.controls.perTransRefundFee.invalid &&
              (parentGroup.controls.perTransRefundFee.dirty ||
                parentGroup.controls.perTransRefundFee.touched)
            "
            class="mt-1"
          >
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransRefundFee.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransRefundFee.errors?.max"
            >
              Value is too high. Max is 999999.99.
            </div>
            <div
              class="text-danger"
              *ngIf="
                parentGroup.controls.perTransRefundFee.errors?.min &&
                (parentGroup.controls.perTransRefundFee.value === 0 ||
                  parentGroup.controls.perTransRefundFee.value === '0.00')
              "
            >
              Value must be greater than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransRefundFee.errors?.pattern"
            >
              Please enter a valid dollar amount.
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group fieldIsRequired" *ngIf="isInstaMed">
        <label
          class="col-md-6 col-lg-4 control-label mt-auto mb-auto text-right"
          for="platformFeeRefund"
        >
          Per eCheck Trans Fee
        </label>

        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text" id="dollarAddOnECheckFee">$</span>
            <input
              class="form-control"
              aria-describedby="dollarAddOnECheckFee"
              [ngClass]="{
                'is-invalid':
                  parentGroup.controls.perTransECheckFee.invalid &&
                  (parentGroup.controls.perTransECheckFee.dirty ||
                    parentGroup.controls.perTransECheckFee.touched)
              }"
              type="number"
              formControlName="perTransECheckFee"
              (blur)="decimalDollarAmount('perTransECheckFee')"
              id="platformECheckFee"
              step="0.01"
              placeholder="0.00"
            />
          </div>
          <div
            *ngIf="
              parentGroup.controls.perTransECheckFee.invalid &&
              (parentGroup.controls.perTransECheckFee.dirty ||
                parentGroup.controls.perTransECheckFee.touched)
            "
            class="mt-1"
          >
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransECheckFee.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransECheckFee.errors?.max"
            >
              Value is too high. Max is 999999.99.
            </div>
            <div
              class="text-danger"
              *ngIf="
                parentGroup.controls.perTransECheckFee.errors?.min &&
                (parentGroup.controls.perTransECheckFee.value === 0 ||
                  parentGroup.controls.perTransECheckFee.value === '0.00')
              "
            >
              Value must be greater than 0.
            </div>
            <div
              class="text-danger"
              *ngIf="parentGroup.controls.perTransECheckFee.errors?.pattern"
            >
              Please enter a valid dollar amount.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset>
    <div class="col-md-8">
      <legend class="row ml-sm-0 mb-3 borderDivide">
        <div class="borderSeparation">Percentage Fees Tiers</div>
      </legend>
    </div>

    <div class="form-group">
      <div class="col-md-8">
        <div
          class="col-md-4 offset-md-4 control-label prctFeeLabel"
          *ngIf="!isInstaMed"
        >
          <strong>Qualified Tier</strong>
        </div>

        <div
          class="col-md-4 offset-md-4 control-label prctFeeLabel"
          *ngIf="isInstaMed"
        >
          <strong>Card Present</strong>
        </div>
        <div class="row fieldIsRequired" *ngIf="!isInstaMed">
          <label
            class="control-label col-md-6 col-lg-4 text-right mt-auto mb-auto"
            for="qTierBoundary"
          >
            upper boundary
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                aria-describedby="qUpperBoundary"
                type="number"
                [ngClass]="{
                  'is-invalid':
                    parentGroup.controls.qualifiedUpperBoundaryPercent
                      .invalid &&
                    (parentGroup.controls.qualifiedUpperBoundaryPercent.dirty ||
                      parentGroup.controls.qualifiedUpperBoundaryPercent
                        .touched)
                }"
                formControlName="qualifiedUpperBoundaryPercent"
                id="qTierBoundary"
                step="0.01"
              />
              <span class="input-group-text" id="qUpperBoundary">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.qualifiedUpperBoundaryPercent.invalid &&
                (parentGroup.controls.qualifiedUpperBoundaryPercent.dirty ||
                  parentGroup.controls.qualifiedUpperBoundaryPercent.touched)
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.qualifiedUpperBoundaryPercent.errors
                    ?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.qualifiedUpperBoundaryPercent.errors?.max
                "
              >
                Value must be less than 1.99.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.qualifiedUpperBoundaryPercent.errors?.min
                "
              >
                Value must be greater than 0.
              </div>
            </div>
          </div>
        </div>
        <div class="row fieldIsRequired mt-1">
          <label
            class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto"
            for="qTierFee"
          >
            fee
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                aria-describedby="qFee"
                [ngClass]="{
                  'is-invalid':
                    parentGroup.controls.qualifiedFeePercent.invalid &&
                    (parentGroup.controls.qualifiedFeePercent.dirty ||
                      parentGroup.controls.qualifiedFeePercent.touched)
                }"
                type="number"
                formControlName="qualifiedFeePercent"
                id="qTierFee"
              />
              <span class="input-group-text" id="qFee">%</span>
            </div>

            <div
              *ngIf="
                parentGroup.controls.qualifiedFeePercent.invalid &&
                (parentGroup.controls.qualifiedFeePercent.dirty ||
                  parentGroup.controls.qualifiedFeePercent.touched)
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.qualifiedFeePercent.errors?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.qualifiedFeePercent.errors?.max"
              >
                Value is too high. Max is 100.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.qualifiedFeePercent.errors?.min &&
                  parentGroup.controls.qualifiedFeePercent.value === 0
                "
              >
                Value must be greater than 0.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.qualifiedFeePercent.errors?.pattern"
              >
                Maximum of 3 decimal places.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <legend></legend>
    <div class="form-group">
      <div class="col-md-8">
        <div
          class="col-md-4 offset-md-4 control-label prctFeeLabel"
          *ngIf="!isInstaMed"
        >
          <strong>Mid-Qualified Tier</strong>
        </div>
        <div
          class="col-md-4 offset-md-4 control-label prctFeeLabel"
          *ngIf="isInstaMed"
        >
          <strong>Card Not Present</strong>
        </div>
        <div class="row fieldIsRequired" *ngIf="!isInstaMed">
          <label
            class="col-md-6 col-lg-4 control-label text-right"
            for="mQTierBoundary"
          >
            upper boundary
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                aria-describedby="mqUpperBoundary"
                [ngClass]="{
                  'is-invalid':
                    (parentGroup.controls.midQualifiedUpperBoundaryPercent
                      .invalid &&
                      parentGroup.controls.midQualifiedUpperBoundaryPercent
                        .touched) ||
                    parentGroup.errors?.midBoundaryLower
                }"
                type="number"
                formControlName="midQualifiedUpperBoundaryPercent"
                id="mQTierBoundary"
                step="0.01"
              />
              <span class="input-group-text" id="mqUpperBoundary">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.midQualifiedUpperBoundaryPercent.invalid &&
                parentGroup.controls.midQualifiedUpperBoundaryPercent.touched
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.midQualifiedUpperBoundaryPercent.errors
                    ?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.midQualifiedUpperBoundaryPercent.errors
                    ?.max
                "
              >
                Value must be less than 2.99.
              </div>
            </div>
            <div
              class="text-danger mt-1"
              *ngIf="parentGroup.errors?.midBoundaryLower"
            >
              Value must be greater than or equal to the qualified upper
              boundary.
            </div>
          </div>
        </div>
        <div class="row fieldIsRequired mt-1">
          <label
            class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto"
            for="mQTierFee"
          >
            fee
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                aria-describedby="mqFee"
                type="number"
                [ngClass]="{
                  'is-invalid':
                    parentGroup.controls.midQualifiedFeePercent.invalid &&
                    (parentGroup.controls.midQualifiedFeePercent.dirty ||
                      parentGroup.controls.midQualifiedFeePercent.touched)
                }"
                formControlName="midQualifiedFeePercent"
                id="mQTierFee"
              />
              <span class="input-group-text" id="mqFee">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.midQualifiedFeePercent.invalid &&
                (parentGroup.controls.midQualifiedFeePercent.dirty ||
                  parentGroup.controls.midQualifiedFeePercent.touched)
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.midQualifiedFeePercent.errors?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.midQualifiedFeePercent.errors?.max"
              >
                Value is too high. Max is 100.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.midQualifiedFeePercent.errors?.min &&
                  parentGroup.controls.midQualifiedFeePercent.value === 0
                "
              >
                Value must be greater than 0.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.midQualifiedFeePercent.errors?.pattern
                "
              >
                Maximum of 3 decimal places.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="!isInstaMed">
      <legend></legend>
      <div class="col-md-8">
        <div class="col-md-4 offset-md-4 control-label prctFeeLabel">
          <strong>Non-Qualified Tier</strong>
        </div>
        <div class="row fieldIsRequired" *ngIf="!isInstaMed">
          <label
            class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto"
            for="nQTierBoundary"
          >
            upper boundary
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                aria-describedby="nonQUpperBoundary"
                [ngClass]="{
                  'is-invalid':
                    (parentGroup.controls.nonQualifiedUpperBoundaryPercent
                      .invalid &&
                      parentGroup.controls.nonQualifiedUpperBoundaryPercent
                        .touched) ||
                    parentGroup.errors?.nonQualifiedBoundaryLower
                }"
                type="number"
                formControlName="nonQualifiedUpperBoundaryPercent"
                id="nQTierBoundary"
                step="0.001"
              />
              <span class="input-group-text" id="nonQUpperBoundary">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.nonQualifiedUpperBoundaryPercent.invalid &&
                parentGroup.controls.nonQualifiedUpperBoundaryPercent.touched
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.nonQualifiedUpperBoundaryPercent.errors
                    ?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.nonQualifiedUpperBoundaryPercent.errors
                    ?.max
                "
              >
                Value is too high. Max is 100.
              </div>
            </div>
            <div
              class="text-danger mt-1"
              *ngIf="parentGroup.errors?.nonQualifiedBoundaryLower"
            >
              Value must be greater than or equal to the mid-qualified upper
              boundary.
            </div>
          </div>
        </div>
        <div class="row fieldIsRequired mt-1">
          <label
            class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto"
            for="nQTierFee"
          >
            fee
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                type="number"
                aria-describedby="nonQFee"
                [ngClass]="{
                  'is-invalid':
                    parentGroup.controls.nonQualifiedFeePercent.invalid &&
                    (parentGroup.controls.nonQualifiedFeePercent.dirty ||
                      parentGroup.controls.nonQualifiedFeePercent.touched)
                }"
                formControlName="nonQualifiedFeePercent"
                id="nQTierFee"
                step="0.001"
              />
              <span class="input-group-text" id="nonQFee">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.nonQualifiedFeePercent.invalid &&
                (parentGroup.controls.nonQualifiedFeePercent.dirty ||
                  parentGroup.controls.nonQualifiedFeePercent.touched)
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.nonQualifiedFeePercent.errors?.required
                "
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.nonQualifiedFeePercent.errors?.max"
              >
                Value is too high. Max is 100.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.nonQualifiedFeePercent.errors?.min &&
                  parentGroup.controls.nonQualifiedFeePercent.value === 0
                "
              >
                Value must be greater than 0.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.nonQualifiedFeePercent.errors?.pattern
                "
              >
                Maximum of 3 decimal places.
              </div>
            </div>
          </div>
        </div>
      </div>
      <legend></legend>
    </div>

    <div class="form-group">
      <div class="col-md-8">
        <div class="col-md-4 offset-md-4 control-label prctFeeLabel">
          <strong>American Express</strong>
        </div>
        <div class="row mt-1" [ngClass]="{ fieldIsRequired: amexFeeRequired }">
          <label
            class="col-md-6 col-lg-4 control-label text-right mt-auto mb-auto"
            for="amexRate"
          >
            fee
          </label>
          <div class="col-md-6">
            <div class="input-group">
              <input
                class="form-control text-right"
                type="number"
                aria-describedby="amxFee"
                [ngClass]="{
                  'is-invalid':
                    parentGroup.controls.amexPercent.invalid &&
                    (parentGroup.controls.amexPercent.dirty ||
                      parentGroup.controls.amexPercent.touched)
                }"
                formControlName="amexPercent"
                id="amexRate"
                step="0.01"
              />
              <span class="input-group-text" id="amxFee">%</span>
            </div>
            <div
              *ngIf="
                parentGroup.controls.amexPercent.invalid &&
                (parentGroup.controls.amexPercent.dirty ||
                  parentGroup.controls.amexPercent.touched)
              "
              class="mt-1"
            >
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.amexPercent.errors?.required"
              >
                Field is required.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.amexPercent.errors?.max"
              >
                Value is too high. Max is 100.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  parentGroup.controls.amexPercent.errors?.min &&
                  parentGroup.controls.amexPercent.value === 0
                "
              >
                Value must be greater than 0.
              </div>
              <div
                class="text-danger"
                *ngIf="parentGroup.controls.amexPercent.errors?.pattern"
              >
                Fee must be positive with a maximum of two decimal places.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <legend></legend>
    <div *ngIf="!isInstaMed" class="form-group col-md-8">
      <div
        class="custom-control form-control-md custom-checkbox col-md-4 offset-md-4"
      >
        <input
          class="custom-control-input checkbox-aligned"
          type="checkbox"
          formControlName="suppressFeeSettlement"
          id="suppressFeeSettlement"
        />
        <label
          class="custom-control-label bold-label"
          for="suppressFeeSettlement"
        >
          Suppress Fee Settlement
        </label>
      </div>
    </div>
  </fieldset>
</div>
